import { render, staticRenderFns } from "./TabelaPropostasFornecedorReajuste.vue?vue&type=template&id=b3a7eb14"
import script from "./TabelaPropostasFornecedorReajuste.vue?vue&type=script&lang=js"
export * from "./TabelaPropostasFornecedorReajuste.vue?vue&type=script&lang=js"
import style0 from "./TabelaPropostasFornecedorReajuste.vue?vue&type=style&index=0&id=b3a7eb14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports